export class TableFilter{
    filterValue: string;
    columns: any;
}